import { render, staticRenderFns } from "./ModattaSettingsBilling.vue?vue&type=template&id=bba7c5c0"
import script from "./ModattaSettingsBilling.vue?vue&type=script&lang=js"
export * from "./ModattaSettingsBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports